import type { ExpandedAuditReport } from '../../../../services/storeAuditReportsService';
import type { AuditReportMetrics } from '../../../../types/auditReportDialogTypes';
import { formatDateTimeMMDDYYYY } from '../../../../utils/formatUtils';

export const formatAuditReportCurrency = (value: number | string | null | undefined): string => {
  if (value === undefined || value === null) {
    return '$0.00';
  }

  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(numericValue)) {
    return '$0.00';
  }

  return `$${numericValue.toFixed(2)}`;
};

export const formatAuditReportNumber = (value: number | string | null | undefined): string => {
  if (value === undefined || value === null) {
    return '0';
  }

  return String(value);
};

export const buildAuditReportMetrics = (report: ExpandedAuditReport | null): AuditReportMetrics => {
  const inventorySold = report?.audit.audit_summary?.total_sold || 0;
  const posSold = report?.audit.pos_summary?.scratcher_count || 0;
  const inventorySoldValue = report?.audit.audit_summary?.total_revenue || 0;
  const posSoldValue = report?.audit.pos_summary?.scratcher_sales || 0;
  const freeTicketsGiven = report?.audit.pos_summary?.scratcher_free_tickets_paid_amount || 0;

  return {
    formattedAuditDate: report?.audit.audit_date
      ? formatDateTimeMMDDYYYY(report.audit.audit_date)
      : '',
    inventorySold,
    posSold,
    inventorySoldValue,
    posSoldValue,
    freeTicketsGiven,
    quantityDiscrepancy: Number(inventorySold) - Number(posSold),
    revenueDiscrepancy:
      Number(inventorySoldValue) - Number(posSoldValue) - Number(freeTicketsGiven),
  };
};
